// Shared source of truth for PowerAgents context variables (BUILDER-07 #3c / BUILDER-08 #3+#7).
// Used by VariablesPanel (declare/validate) and the tool editor (insert {{name}} tokens).

// System-provided variables, always available in every conversation (filled by the runtime).
export const BUILTINS = [
  'conversation_id',
  'contact_name',
  'contact_phone',
  'account_id',
  'agent_id',
  'current_datetime',
  // Presentes só quando a mensagem responde a um disparo do Outbound (runtime/disparo.py).
  'disparo_template',
  'disparo_lote',
  'botao',
];

// Declared variable names: lowercase letters, digits, underscore.
export const NAME_RE = /^[a-z0-9_]+$/;

// A literal "{{name}}" token. Kept as a helper because writing {{name}} inline in a Vue
// template breaks the interpolation parser.
export const varToken = name => '{{' + name + '}}';

// An "AI value" token (BUILDER-09 #3): a single-brace "{name}" placeholder the n8n compiler
// turns into $fromAI('name', <description>, 'string') — volatile, filled by the model from its
// description, no global constant. The description is carried in the tool's params_schema.
export const aiToken = name => '{' + name + '}';

// Split a field value into text / context-var / ai-value segments so the editor can render
// each token as a coloured pill. {{var}} is matched before {name} (the alternation tries the
// double-brace form first at each position), so nested braces never mis-parse.
const TOKEN_RE = /\{\{([a-z0-9_]+)\}\}|\{([a-z0-9_]+)\}/g;

export function parseTokens(str) {
  const s = str || '';
  const out = [];
  let last = 0;
  let m = TOKEN_RE.exec(s);
  while (m !== null) {
    if (m.index > last)
      out.push({ type: 'text', value: s.slice(last, m.index) });
    if (m[1] != null) out.push({ type: 'var', name: m[1], value: m[0] });
    else out.push({ type: 'ai', name: m[2], value: m[0] });
    last = m.index + m[0].length;
    m = TOKEN_RE.exec(s);
  }
  if (last < s.length) out.push({ type: 'text', value: s.slice(last) });
  return out;
}
